import { Component } from '@verndale/core';
import imagesLoaded from 'imagesloaded';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $bgImages: this.el.querySelector('.generic-masthead__bg-img-wrapper')
    };
    this.el.style = `--bg-img-scale: ${(window.innerWidth - 1360) / 560 / 6 + 0.85};`;
  }

  addListeners() {
    if (this.dom.$bgImages) imagesLoaded(this.el, () => this.runAnimations());
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  runAnimations() {
    this.el.classList.add('generic-masthead--loaded');
  }

  handleResize() {
    const bgImgScale = (window.innerWidth - 1360) / 560 / 6 + 0.85;
    this.el.style = `--bg-img-scale: ${bgImgScale}`;
  }
}

export default Module;
